
import { Fragment } from 'vue-frag'
export default {
  components:{
    Fragment
  },
  props: ["element"],
  name: "hyperCoreText",
};
